export const ROLE_DEFAULT_ROUTE: { [role: string]: string } = {
  ADMIN: '/admin/users',
  SUPER_ADMIN: '/admin/users',
  SUPPORT: '/admin/users',
  STAFF: '/admin/members',
  MEMBER: '/member/profile',
};

export const adminSidebarData = [
  {
    routerLink: '/',
    icon: 'tuiIconHome',
    label: 'Dashboard',
    permission: 'dashboard',
  },
  {
    icon: 'tuiIconUser',
    label: 'Users',
    subMenu: [
      {
        routerLink: '/admin/users',
        label: 'View Users',
      },
      {
        routerLink: '/admin/users/add-edit',
        label: 'Add User',
      },
    ],
  },
  {
    icon: 'tuiIconUsers',
    label: 'Members',
    subMenu: [
      {
        routerLink: '/admin/members',
        label: 'View Members',
      },
      {
        routerLink: '/admin/members/add-edit',
        label: 'Add Member',
      },
    ],
  },
  {
    icon: 'tuiIconArchive',
    label: 'Inventory',
    subMenu: [
      {
        routerLink: '/admin/inventory',
        label: 'View Inventory',
      },
      {
        routerLink: '/admin/inventory/add-edit',
        label: 'Add Inventory',
      },
    ],
  },
  {
    icon: 'tuiIconBriefcase',
    label: 'Sales',
    subMenu: [
      {
        routerLink: '/admin/sales',
        label: 'View Sales',
      },
      {
        routerLink: '/admin/sales/add-edit',
        label: 'Add Sales',
      },
    ],
  },
  {
    icon: 'tuiIconCreditCard',
    label: 'Payments',
    subMenu: [
      {
        routerLink: '/admin/payments',
        label: 'View Payments',
      },
      {
        routerLink: '/admin/payment/add-edit',
        label: 'Add Payment',
      },
    ],
  },
  {
    icon: 'tuiIconUserCheck',
    label: 'Attendance',
    subMenu: [
      {
        routerLink: '/admin/attendance',
        label: 'View Attendance',
      },
      {
        routerLink: '/admin/attendance/add-edit',
        label: 'Add Attendance',
      },
    ],
  },
  {
    icon: 'tuiIconVolume2',
    label: 'Announcements',
    subMenu: [
      {
        routerLink: '/admin/announcements',
        label: 'View Announcements',
      },
      {
        routerLink: '/admin/announcement/add-edit',
        label: 'Add Announcement',
      },
    ],
  },
  {
    icon: 'tuiIconList',
    label: 'Activity Logs',
    subMenu: [
      {
        routerLink: '/admin/logs',
        label: 'View Logs',
      },
    ],
  },
];

export const supportSidebarData = [
  {
    routerLink: '/',
    icon: 'tuiIconHome',
    label: 'Dashboard',
    permission: 'dashboard',
  },
  {
    icon: 'tuiIconUser',
    label: 'Users',
    subMenu: [
      {
        routerLink: '/admin/users',
        label: 'View Users',
      },
      {
        routerLink: '/admin/users/add-edit',
        label: 'Add User',
      },
    ],
  },
  {
    icon: 'tuiIconUsers',
    label: 'Members',
    subMenu: [
      {
        routerLink: '/admin/members',
        label: 'View Members',
      },
      {
        routerLink: '/admin/members/add-edit',
        label: 'Add Member',
      },
    ],
  },
  {
    icon: 'tuiIconArchive',
    label: 'Inventory',
    subMenu: [
      {
        routerLink: '/admin/inventory',
        label: 'View Inventory',
      },
      {
        routerLink: '/admin/inventory/add-edit',
        label: 'Add Inventory',
      },
    ],
  },
  {
    icon: 'tuiIconBriefcase',
    label: 'Sales',
    subMenu: [
      {
        routerLink: '/admin/sales',
        label: 'View Sales',
      },
      {
        routerLink: '/admin/sales/add-edit',
        label: 'Add Sales',
      },
    ],
  },
  {
    icon: 'tuiIconCreditCard',
    label: 'Payments',
    subMenu: [
      {
        routerLink: '/admin/payments',
        label: 'View Payments',
      },
      {
        routerLink: '/admin/payment/add-edit',
        label: 'Add Payment',
      },
    ],
  },
  {
    icon: 'tuiIconUserCheck',
    label: 'Attendance',
    subMenu: [
      {
        routerLink: '/admin/attendance',
        label: 'View Attendance',
      },
      {
        routerLink: '/admin/attendance/add-edit',
        label: 'Add Attendance',
      },
    ],
  },
  {
    icon: 'tuiIconVolume2',
    label: 'Announcements',
    subMenu: [
      {
        routerLink: '/admin/announcements',
        label: 'View Announcements',
      },
      {
        routerLink: '/admin/announcement/add-edit',
        label: 'Add Announcement',
      },
    ],
  },
  {
    icon: 'tuiIconList',
    label: 'Activity Logs',
    subMenu: [
      {
        routerLink: '/admin/logs',
        label: 'View Logs',
      },
    ],
  },
];

export const staffSidebarData = [
  {
    routerLink: '/',
    icon: 'tuiIconHome',
    label: 'Dashboard',
    permission: 'dashboard',
  },
  {
    icon: 'tuiIconUsers',
    label: 'Members',
    subMenu: [
      {
        routerLink: '/admin/members',
        label: 'View Members',
      },
      {
        routerLink: '/admin/members/add-edit',
        label: 'Add Member',
      },
    ],
  },
  {
    icon: 'tuiIconArchive',
    label: 'Inventory',
    subMenu: [
      {
        routerLink: '/admin/inventory',
        label: 'View Inventory',
      },
      {
        routerLink: '/admin/inventory/add-edit',
        label: 'Add Inventory',
      },
    ],
  },
  {
    icon: 'tuiIconBriefcase',
    label: 'Sales',
    subMenu: [
      {
        routerLink: '/admin/sales',
        label: 'View Sales',
      },
      {
        routerLink: '/admin/sales/add-edit',
        label: 'Add Sales',
      },
    ],
  },
  {
    icon: 'tuiIconUserCheck',
    label: 'Attendance',
    subMenu: [
      {
        routerLink: '/admin/attendance',
        label: 'View Attendance',
      },
      {
        routerLink: '/admin/attendance/add-edit',
        label: 'Add Attendance',
      },
    ],
  },
];

export const memberSidebarData = [
  {
    routerLink: `/member/profile`,
    icon: 'tuiIconUser',
    label: 'Profile',
  },
];
